import { __decorate, __metadata } from "tslib";
import { containerResolver } from '../protocol/resolver';
/**
 * Used to allow functions/classes to specify an optional dependency, which will be resolved
 *      only if already registred with the container.
 */
var OptionalResolver = /** @class */ (function () {
    /**
     * Creates an instance of the Optional class.
     * @param key The key to optionally resolve for.
     * @param checkParent Indicates whether or not the parent container hierarchy should be checked.
     */
    function OptionalResolver(key, checkParent) {
        if (checkParent === void 0) { checkParent = true; }
        this._key = key;
        this._checkParent = checkParent;
    }
    OptionalResolver_1 = OptionalResolver;
    /**
     * Creates an Optional Resolver for the supplied key.
     * @param key The key to optionally resolve for.
     * @param [checkParent=true] Indicates whether or not the parent container hierarchy should be checked.
     * @return Returns an instance of Optional for the key.
     */
    OptionalResolver.of = function (key, checkParent) {
        if (checkParent === void 0) { checkParent = true; }
        return new OptionalResolver_1(key, checkParent);
    };
    /**
     * Called by the container to provide optional resolution of the key.
     * @param container The container to resolve from.
     * @return Returns the instance if found; otherwise null.
     */
    OptionalResolver.prototype.get = function (container) {
        if (container.hasHandler(this._key, this._checkParent)) {
            return container.get(this._key);
        }
        return null;
    };
    var OptionalResolver_1;
    OptionalResolver = OptionalResolver_1 = __decorate([
        containerResolver,
        __metadata("design:paramtypes", [Object, Object])
    ], OptionalResolver);
    return OptionalResolver;
}());
export { OptionalResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3B0aW9uYWxSZXNvbHZlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk9wdGlvbmFsUmVzb2x2ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQU9BLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBR3pEOzs7R0FHRztBQUVIO0lBaUJJOzs7O09BSUc7SUFDSCwwQkFBbUIsR0FBVyxFQUFFLFdBQWtCO1FBQWxCLDRCQUFBLEVBQUEsa0JBQWtCO1FBQzlDLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDO1FBQ2hCLElBQUksQ0FBQyxZQUFZLEdBQUcsV0FBVyxDQUFDO0lBQ3BDLENBQUM7eUJBekJRLGdCQUFnQjtJQUN6Qjs7Ozs7T0FLRztJQUNXLG1CQUFFLEdBQWhCLFVBQW9CLEdBQVcsRUFBRSxXQUFrQjtRQUFsQiw0QkFBQSxFQUFBLGtCQUFrQjtRQUMvQyxPQUFPLElBQUksa0JBQWdCLENBQUMsR0FBRyxFQUFFLFdBQVcsQ0FBQyxDQUFDO0lBQ2xELENBQUM7SUFrQkQ7Ozs7T0FJRztJQUNJLDhCQUFHLEdBQVYsVUFBVyxTQUFvQjtRQUMzQixJQUFJLFNBQVMsQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsWUFBWSxDQUFDLEVBQUU7WUFDcEQsT0FBTyxTQUFTLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztTQUNuQztRQUVELE9BQU8sSUFBSSxDQUFDO0lBQ2hCLENBQUM7O0lBdENRLGdCQUFnQjtRQUQ1QixpQkFBaUI7O09BQ0wsZ0JBQWdCLENBdUM1QjtJQUFELHVCQUFDO0NBQUEsQUF2Q0QsSUF1Q0M7U0F2Q1ksZ0JBQWdCIn0=